// EN
export const calendarHotel = {
  btn: {
    today: "Today",
  },
  summary: {
    availableLabel: "Available",
  },
  tooltip: {
    closed: "Closed",
    dragToCreate: "Drag to select (create booking)",
  },
  labels: {
    room: "room",
    rooms: "rooms",
    number: "NUMBER:",
    capacityIconAlt: "Capacity",
    maintenanceBadge: "MAINT.",
  },
  toasts: {
    reservationCreatedOk: "Booking created successfully.",
    reservationCreateErrPrefix: "Could not create the booking: ",
    roomChangedOk: "Room changed successfully",
    roomChangedErr: "Error changing the room",
    roomTypeChangedOk: "Reservation moved to {type}",
  },
  warn: {
    selectTwoDays: "Select at least two days (check-in and check-out).",
  },
  errors: {
    closedForBooking: "You can’t book a closed room/slot.",
    noAvailabilityTitle: "No availability",
    noAvailabilityDetail: "There are no rooms available for that type on those dates.",
    noRatesTitle: "No rates assigned",
    noRatesDetail: "There are no rates available for that type on those dates.",
    missingDataTitle: "Missing data",
    missingDataDetail: "Please fill in all required fields.",
  },
  maintenanceModal: {
    titleFallback: "Room",
    statusSection: "Status",
    closeForMaintenance: "Close for maintenance",
    open: "Open",
    hint:
      "When a room is under maintenance, it cannot be sold and its cells will appear in red. Existing bookings are respected.",
    actions: {
      cancel: "Cancel",
      save: "Save",
      saving: "Saving…",
    },
  },

  // ===== NEW: Reservation modal =====
  modal: {
    title: "Register new booking",
    startDate: "Check-in",
    endDate: "Check-out",
    roomType: "Room type",
    roomTypePlaceholder: "Select type",
    quantity: "Number of rooms",
    available: "available",
    guestName: "Guest responsible",
    guestNamePlaceholder: "Person responsible for the booking",
    guests: "Number of guests",
    guestsPlaceholder: "Number of guests",
    phone: "Phone",
    email: "Email",
    notes: "Note",
    notesPlaceholder: "Internal booking notes (e.g. late arrival, crib, allergies…)",
    addType: "Add another room type",
    price: "Price",
    pricePlaceholder: "Enter price",
    cancel: "Cancel",
    create: "Create booking",
  },

  // ===== Validations =====
  validation: {
    minGuestsTitle: "Not enough guests",
    minGuestsDetail: "There must be at least {min} guest(s) for {rooms} room(s).",
    maxGuestsTitle: "Guest limit exceeded",
    maxGuestsDetail: "Maximum {maxPerRoom} guests per room ({maxTotal} total for {rooms} rooms).",
    maxRoomsTitle: "Limit exceeded",
    maxRoomsDetail: "You can’t book more than {max} rooms.",
  },

  // ===== Promotions & Taxes =====
  promotions: {
    limitTitle: "Limit reached",
    limitDetail: "You can’t add more than 1 promotion.",
  },
  taxes: {
    limitTitle: "Limit reached",
    limitDetail: "You can’t add more than 1 tax.",
  },
};
